import React, { createContext, useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';

// Where the user is standing, for the bolita. Routes cover the cliente page,
// but ContratoView and FianzaView are modals: they register themselves here
// while open so a pendiente filed from the bolita starts attached to what is
// on screen. A stack, because FianzaView opens on top of ContratoView and the
// narrowest open surface wins.
const Ctx = createContext({ contexto: null, push: () => () => {} });

export function PendienteContextoProvider({ children }) {
  const [stack, setStack] = useState([]);
  const seq = useRef(0);

  const push = useCallback((ctx) => {
    const id = seq.current += 1;
    setStack((s) => [...s, { id, ...ctx }]);
    return () => setStack((s) => s.filter((e) => e.id !== id));
  }, []);

  const value = useMemo(
    () => ({ contexto: stack.length ? stack[stack.length - 1] : null, push }),
    [stack, push]
  );
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

/** The narrowest surface currently open (or null). */
export function usePendienteContexto() {
  return useContext(Ctx).contexto;
}

/**
 * Register a surface's context while `activo`. Re-registers when the ids
 * change (the same modal can switch fianza). Cleans up on unmount.
 *
 * @param {boolean} activo
 * @param {{clienteId?:string, contratoId?:string, fianzaId?:string,
 *   convenioId?:string, contratoTitulo?:string, numeroFianza?:string,
 *   afianzadoraRaw?:string, etiqueta?:string}} ctx
 */
export function useRegistrarContextoPendiente(activo, ctx) {
  const { push } = useContext(Ctx);
  const key = JSON.stringify(ctx || {});
  useEffect(() => {
    if (!activo) return undefined;
    return push(JSON.parse(key));
  }, [activo, key, push]);
}

export default PendienteContextoProvider;
